import { onMounted as re, nextTick as _n, getCurrentScope as bn, onScopeDispose as Cn, unref as E, getCurrentInstance as ze, computed as Z, ref as k, watch as at, isRef as Mn, reactive as kn, defineComponent as Nn, openBlock as Xt, createElementBlock as me, Fragment as An, createElementVNode as En, normalizeStyle as Sn, createBlock as $n, resolveDynamicComponent as Tn, normalizeProps as Rn, guardReactiveProps as Fn, createCommentVNode as On } from "vue";
function Dn(t) {
  return bn() ? (Cn(t), !0) : !1;
}
function Le(t) {
  return typeof t == "function" ? t() : E(t);
}
const Hn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function Bn(t) {
  return ze();
}
function In(t, e = !0, n) {
  Bn() ? re(t, n) : e ? t() : _n(t);
}
function W(t) {
  var e;
  const n = Le(t);
  return (e = n?.$el) != null ? e : n;
}
const qe = Hn ? window : void 0;
function Pn() {
  const t = k(!1), e = ze();
  return e && re(() => {
    t.value = !0;
  }, e), t;
}
function zn(t) {
  const e = Pn();
  return Z(() => (e.value, !!t()));
}
function Ln(t) {
  return JSON.parse(JSON.stringify(t));
}
function ge(t, e = {}) {
  const n = k({}), {
    manual: r,
    clone: i = Ln,
    // watch options
    deep: o = !0,
    immediate: a = !0
  } = e;
  function l() {
    n.value = i(Le(t));
  }
  return !r && (Mn(t) || typeof t == "function") ? at(t, l, {
    ...e,
    deep: o,
    immediate: a
  }) : l(), { cloned: n, sync: l };
}
function qn(t, e, n = {}) {
  const { window: r = qe, ...i } = n;
  let o;
  const a = zn(() => r && "ResizeObserver" in r), l = () => {
    o && (o.disconnect(), o = void 0);
  }, s = Z(() => Array.isArray(t) ? t.map((h) => W(h)) : [W(t)]), u = at(
    s,
    (h) => {
      if (l(), a.value && r) {
        o = new ResizeObserver(e);
        for (const f of h)
          f && o.observe(f, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), u();
  };
  return Dn(c), {
    isSupported: a,
    stop: c
  };
}
function Xn(t, e = { width: 0, height: 0 }, n = {}) {
  const { window: r = qe, box: i = "content-box" } = n, o = Z(() => {
    var h, f;
    return (f = (h = W(t)) == null ? void 0 : h.namespaceURI) == null ? void 0 : f.includes("svg");
  }), a = k(e.width), l = k(e.height), { stop: s } = qn(
    t,
    ([h]) => {
      const f = i === "border-box" ? h.borderBoxSize : i === "content-box" ? h.contentBoxSize : h.devicePixelContentBoxSize;
      if (r && o.value) {
        const p = W(t);
        if (p) {
          const g = p.getBoundingClientRect();
          a.value = g.width, l.value = g.height;
        }
      } else if (f) {
        const p = Array.isArray(f) ? f : [f];
        a.value = p.reduce((g, { inlineSize: v }) => g + v, 0), l.value = p.reduce((g, { blockSize: v }) => g + v, 0);
      } else
        a.value = h.contentRect.width, l.value = h.contentRect.height;
    },
    n
  );
  In(() => {
    const h = W(t);
    h && (a.value = "offsetWidth" in h ? h.offsetWidth : e.width, l.value = "offsetHeight" in h ? h.offsetHeight : e.height);
  });
  const u = at(
    () => W(t),
    (h) => {
      a.value = h ? e.width : 0, l.value = h ? e.height : 0;
    }
  );
  function c() {
    s(), u();
  }
  return {
    width: a,
    height: l,
    stop: c
  };
}
function bt(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Vn(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Xe(t) {
  let e, n, r;
  t.length !== 2 ? (e = bt, n = (l, s) => bt(t(l), s), r = (l, s) => t(l) - s) : (e = t === bt || t === Vn ? t : Yn, n = t, r = t);
  function i(l, s, u = 0, c = l.length) {
    if (u < c) {
      if (e(s, s) !== 0) return c;
      do {
        const h = u + c >>> 1;
        n(l[h], s) < 0 ? u = h + 1 : c = h;
      } while (u < c);
    }
    return u;
  }
  function o(l, s, u = 0, c = l.length) {
    if (u < c) {
      if (e(s, s) !== 0) return c;
      do {
        const h = u + c >>> 1;
        n(l[h], s) <= 0 ? u = h + 1 : c = h;
      } while (u < c);
    }
    return u;
  }
  function a(l, s, u = 0, c = l.length) {
    const h = i(l, s, u, c - 1);
    return h > u && r(l[h - 1], s) > -r(l[h], s) ? h - 1 : h;
  }
  return { left: i, center: a, right: o };
}
function Yn() {
  return 0;
}
function Wn(t) {
  return t === null ? NaN : +t;
}
const Gn = Xe(bt), Un = Gn.right;
Xe(Wn).center;
const Zn = Math.sqrt(50), Jn = Math.sqrt(10), Kn = Math.sqrt(2);
function Nt(t, e, n) {
  const r = (e - t) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= Zn ? 10 : o >= Jn ? 5 : o >= Kn ? 2 : 1;
  let l, s, u;
  return i < 0 ? (u = Math.pow(10, -i) / a, l = Math.round(t * u), s = Math.round(e * u), l / u < t && ++l, s / u > e && --s, u = -u) : (u = Math.pow(10, i) * a, l = Math.round(t / u), s = Math.round(e / u), l * u < t && ++l, s * u > e && --s), s < l && 0.5 <= n && n < 2 ? Nt(t, e, n * 2) : [l, s, u];
}
function Qn(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0)) return [];
  if (t === e) return [t];
  const r = e < t, [i, o, a] = r ? Nt(e, t, n) : Nt(t, e, n);
  if (!(o >= i)) return [];
  const l = o - i + 1, s = new Array(l);
  if (r)
    if (a < 0) for (let u = 0; u < l; ++u) s[u] = (o - u) / -a;
    else for (let u = 0; u < l; ++u) s[u] = (o - u) * a;
  else if (a < 0) for (let u = 0; u < l; ++u) s[u] = (i + u) / -a;
  else for (let u = 0; u < l; ++u) s[u] = (i + u) * a;
  return s;
}
function Wt(t, e, n) {
  return e = +e, t = +t, n = +n, Nt(t, e, n)[2];
}
function jn(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, i = r ? Wt(e, t, n) : Wt(t, e, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
var tr = { value: () => {
} };
function Ve() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Ct(n);
}
function Ct(t) {
  this._ = t;
}
function er(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Ct.prototype = Ve.prototype = {
  constructor: Ct,
  on: function(t, e) {
    var n = this._, r = er(t + "", n), i, o = -1, a = r.length;
    if (arguments.length < 2) {
      for (; ++o < a; ) if ((i = (t = r[o]).type) && (i = nr(n[i], t.name))) return i;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++o < a; )
      if (i = (t = r[o]).type) n[i] = ve(n[i], t.name, e);
      else if (e == null) for (i in n) n[i] = ve(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new Ct(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, o; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (o = this._[t], r = 0, i = o.length; r < i; ++r) o[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, o = r.length; i < o; ++i) r[i].value.apply(e, n);
  }
};
function nr(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function ve(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = tr, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var Gt = "http://www.w3.org/1999/xhtml";
const ye = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Gt,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function It(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), ye.hasOwnProperty(e) ? { space: ye[e], local: t } : t;
}
function rr(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === Gt && e.documentElement.namespaceURI === Gt ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function ir(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Ye(t) {
  var e = It(t);
  return (e.local ? ir : rr)(e);
}
function or() {
}
function ie(t) {
  return t == null ? or : function() {
    return this.querySelector(t);
  };
}
function ar(t) {
  typeof t != "function" && (t = ie(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = e[i], a = o.length, l = r[i] = new Array(a), s, u, c = 0; c < a; ++c)
      (s = o[c]) && (u = t.call(s, s.__data__, c, o)) && ("__data__" in s && (u.__data__ = s.__data__), l[c] = u);
  return new N(r, this._parents);
}
function We(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function lr() {
  return [];
}
function Ge(t) {
  return t == null ? lr : function() {
    return this.querySelectorAll(t);
  };
}
function ur(t) {
  return function() {
    return We(t.apply(this, arguments));
  };
}
function sr(t) {
  typeof t == "function" ? t = ur(t) : t = Ge(t);
  for (var e = this._groups, n = e.length, r = [], i = [], o = 0; o < n; ++o)
    for (var a = e[o], l = a.length, s, u = 0; u < l; ++u)
      (s = a[u]) && (r.push(t.call(s, s.__data__, u, a)), i.push(s));
  return new N(r, i);
}
function Ue(t) {
  return function() {
    return this.matches(t);
  };
}
function Ze(t) {
  return function(e) {
    return e.matches(t);
  };
}
var cr = Array.prototype.find;
function fr(t) {
  return function() {
    return cr.call(this.children, t);
  };
}
function hr() {
  return this.firstElementChild;
}
function dr(t) {
  return this.select(t == null ? hr : fr(typeof t == "function" ? t : Ze(t)));
}
var pr = Array.prototype.filter;
function mr() {
  return Array.from(this.children);
}
function gr(t) {
  return function() {
    return pr.call(this.children, t);
  };
}
function vr(t) {
  return this.selectAll(t == null ? mr : gr(typeof t == "function" ? t : Ze(t)));
}
function yr(t) {
  typeof t != "function" && (t = Ue(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = e[i], a = o.length, l = r[i] = [], s, u = 0; u < a; ++u)
      (s = o[u]) && t.call(s, s.__data__, u, o) && l.push(s);
  return new N(r, this._parents);
}
function Je(t) {
  return new Array(t.length);
}
function xr() {
  return new N(this._enter || this._groups.map(Je), this._parents);
}
function At(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
At.prototype = {
  constructor: At,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function wr(t) {
  return function() {
    return t;
  };
}
function _r(t, e, n, r, i, o) {
  for (var a = 0, l, s = e.length, u = o.length; a < u; ++a)
    (l = e[a]) ? (l.__data__ = o[a], r[a] = l) : n[a] = new At(t, o[a]);
  for (; a < s; ++a)
    (l = e[a]) && (i[a] = l);
}
function br(t, e, n, r, i, o, a) {
  var l, s, u = /* @__PURE__ */ new Map(), c = e.length, h = o.length, f = new Array(c), p;
  for (l = 0; l < c; ++l)
    (s = e[l]) && (f[l] = p = a.call(s, s.__data__, l, e) + "", u.has(p) ? i[l] = s : u.set(p, s));
  for (l = 0; l < h; ++l)
    p = a.call(t, o[l], l, o) + "", (s = u.get(p)) ? (r[l] = s, s.__data__ = o[l], u.delete(p)) : n[l] = new At(t, o[l]);
  for (l = 0; l < c; ++l)
    (s = e[l]) && u.get(f[l]) === s && (i[l] = s);
}
function Cr(t) {
  return t.__data__;
}
function Mr(t, e) {
  if (!arguments.length) return Array.from(this, Cr);
  var n = e ? br : _r, r = this._parents, i = this._groups;
  typeof t != "function" && (t = wr(t));
  for (var o = i.length, a = new Array(o), l = new Array(o), s = new Array(o), u = 0; u < o; ++u) {
    var c = r[u], h = i[u], f = h.length, p = kr(t.call(c, c && c.__data__, u, r)), g = p.length, v = l[u] = new Array(g), d = a[u] = new Array(g), m = s[u] = new Array(f);
    n(c, h, v, d, m, p, e);
    for (var w = 0, _ = 0, C, b; w < g; ++w)
      if (C = v[w]) {
        for (w >= _ && (_ = w + 1); !(b = d[_]) && ++_ < g; ) ;
        C._next = b || null;
      }
  }
  return a = new N(a, r), a._enter = l, a._exit = s, a;
}
function kr(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Nr() {
  return new N(this._exit || this._groups.map(Je), this._parents);
}
function Ar(t, e, n) {
  var r = this.enter(), i = this, o = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? o.remove() : n(o), r && i ? r.merge(i).order() : i;
}
function Er(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, o = r.length, a = Math.min(i, o), l = new Array(i), s = 0; s < a; ++s)
    for (var u = n[s], c = r[s], h = u.length, f = l[s] = new Array(h), p, g = 0; g < h; ++g)
      (p = u[g] || c[g]) && (f[g] = p);
  for (; s < i; ++s)
    l[s] = n[s];
  return new N(l, this._parents);
}
function Sr() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, o = r[i], a; --i >= 0; )
      (a = r[i]) && (o && a.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(a, o), o = a);
  return this;
}
function $r(t) {
  t || (t = Tr);
  function e(h, f) {
    return h && f ? t(h.__data__, f.__data__) : !h - !f;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), o = 0; o < r; ++o) {
    for (var a = n[o], l = a.length, s = i[o] = new Array(l), u, c = 0; c < l; ++c)
      (u = a[c]) && (s[c] = u);
    s.sort(e);
  }
  return new N(i, this._parents).order();
}
function Tr(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Rr() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function Fr() {
  return Array.from(this);
}
function Or() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, o = r.length; i < o; ++i) {
      var a = r[i];
      if (a) return a;
    }
  return null;
}
function Dr() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function Hr() {
  return !this.node();
}
function Br(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], o = 0, a = i.length, l; o < a; ++o)
      (l = i[o]) && t.call(l, l.__data__, o, i);
  return this;
}
function Ir(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Pr(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function zr(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function Lr(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function qr(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function Xr(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function Vr(t, e) {
  var n = It(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? Pr : Ir : typeof e == "function" ? n.local ? Xr : qr : n.local ? Lr : zr)(n, e));
}
function Ke(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function Yr(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function Wr(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function Gr(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function Ur(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? Yr : typeof e == "function" ? Gr : Wr)(t, e, n ?? "")) : J(this.node(), t);
}
function J(t, e) {
  return t.style.getPropertyValue(e) || Ke(t).getComputedStyle(t, null).getPropertyValue(e);
}
function Zr(t) {
  return function() {
    delete this[t];
  };
}
function Jr(t, e) {
  return function() {
    this[t] = e;
  };
}
function Kr(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function Qr(t, e) {
  return arguments.length > 1 ? this.each((e == null ? Zr : typeof e == "function" ? Kr : Jr)(t, e)) : this.node()[t];
}
function Qe(t) {
  return t.trim().split(/^|\s+/);
}
function oe(t) {
  return t.classList || new je(t);
}
function je(t) {
  this._node = t, this._names = Qe(t.getAttribute("class") || "");
}
je.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function tn(t, e) {
  for (var n = oe(t), r = -1, i = e.length; ++r < i; ) n.add(e[r]);
}
function en(t, e) {
  for (var n = oe(t), r = -1, i = e.length; ++r < i; ) n.remove(e[r]);
}
function jr(t) {
  return function() {
    tn(this, t);
  };
}
function ti(t) {
  return function() {
    en(this, t);
  };
}
function ei(t, e) {
  return function() {
    (e.apply(this, arguments) ? tn : en)(this, t);
  };
}
function ni(t, e) {
  var n = Qe(t + "");
  if (arguments.length < 2) {
    for (var r = oe(this.node()), i = -1, o = n.length; ++i < o; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? ei : e ? jr : ti)(n, e));
}
function ri() {
  this.textContent = "";
}
function ii(t) {
  return function() {
    this.textContent = t;
  };
}
function oi(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function ai(t) {
  return arguments.length ? this.each(t == null ? ri : (typeof t == "function" ? oi : ii)(t)) : this.node().textContent;
}
function li() {
  this.innerHTML = "";
}
function ui(t) {
  return function() {
    this.innerHTML = t;
  };
}
function si(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function ci(t) {
  return arguments.length ? this.each(t == null ? li : (typeof t == "function" ? si : ui)(t)) : this.node().innerHTML;
}
function fi() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function hi() {
  return this.each(fi);
}
function di() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function pi() {
  return this.each(di);
}
function mi(t) {
  var e = typeof t == "function" ? t : Ye(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function gi() {
  return null;
}
function vi(t, e) {
  var n = typeof t == "function" ? t : Ye(t), r = e == null ? gi : typeof e == "function" ? e : ie(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function yi() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function xi() {
  return this.each(yi);
}
function wi() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function _i() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function bi(t) {
  return this.select(t ? _i : wi);
}
function Ci(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function Mi(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function ki(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function Ni(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, o; n < i; ++n)
        o = e[n], (!t.type || o.type === t.type) && o.name === t.name ? this.removeEventListener(o.type, o.listener, o.options) : e[++r] = o;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function Ai(t, e, n) {
  return function() {
    var r = this.__on, i, o = Mi(e);
    if (r) {
      for (var a = 0, l = r.length; a < l; ++a)
        if ((i = r[a]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = o, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, o, n), i = { type: t.type, name: t.name, value: e, listener: o, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function Ei(t, e, n) {
  var r = ki(t + ""), i, o = r.length, a;
  if (arguments.length < 2) {
    var l = this.node().__on;
    if (l) {
      for (var s = 0, u = l.length, c; s < u; ++s)
        for (i = 0, c = l[s]; i < o; ++i)
          if ((a = r[i]).type === c.type && a.name === c.name)
            return c.value;
    }
    return;
  }
  for (l = e ? Ai : Ni, i = 0; i < o; ++i) this.each(l(r[i], e, n));
  return this;
}
function nn(t, e, n) {
  var r = Ke(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function Si(t, e) {
  return function() {
    return nn(this, t, e);
  };
}
function $i(t, e) {
  return function() {
    return nn(this, t, e.apply(this, arguments));
  };
}
function Ti(t, e) {
  return this.each((typeof e == "function" ? $i : Si)(t, e));
}
function* Ri() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, o = r.length, a; i < o; ++i)
      (a = r[i]) && (yield a);
}
var ae = [null];
function N(t, e) {
  this._groups = t, this._parents = e;
}
function ct() {
  return new N([[document.documentElement]], ae);
}
function Fi() {
  return this;
}
N.prototype = ct.prototype = {
  constructor: N,
  select: ar,
  selectAll: sr,
  selectChild: dr,
  selectChildren: vr,
  filter: yr,
  data: Mr,
  enter: xr,
  exit: Nr,
  join: Ar,
  merge: Er,
  selection: Fi,
  order: Sr,
  sort: $r,
  call: Rr,
  nodes: Fr,
  node: Or,
  size: Dr,
  empty: Hr,
  each: Br,
  attr: Vr,
  style: Ur,
  property: Qr,
  classed: ni,
  text: ai,
  html: ci,
  raise: hi,
  lower: pi,
  append: mi,
  insert: vi,
  remove: xi,
  clone: bi,
  datum: Ci,
  on: Ei,
  dispatch: Ti,
  [Symbol.iterator]: Ri
};
function Ut(t) {
  return typeof t == "string" ? new N([[document.querySelector(t)]], [document.documentElement]) : new N([[t]], ae);
}
function Oi(t) {
  return typeof t == "string" ? new N([document.querySelectorAll(t)], [document.documentElement]) : new N([We(t)], ae);
}
function le(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function rn(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function ft() {
}
var lt = 0.7, Et = 1 / lt, U = "\\s*([+-]?\\d+)\\s*", ut = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", F = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Di = /^#([0-9a-f]{3,8})$/, Hi = new RegExp(`^rgb\\(${U},${U},${U}\\)$`), Bi = new RegExp(`^rgb\\(${F},${F},${F}\\)$`), Ii = new RegExp(`^rgba\\(${U},${U},${U},${ut}\\)$`), Pi = new RegExp(`^rgba\\(${F},${F},${F},${ut}\\)$`), zi = new RegExp(`^hsl\\(${ut},${F},${F}\\)$`), Li = new RegExp(`^hsla\\(${ut},${F},${F},${ut}\\)$`), xe = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
le(ft, q, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: we,
  // Deprecated! Use color.formatHex.
  formatHex: we,
  formatHex8: qi,
  formatHsl: Xi,
  formatRgb: _e,
  toString: _e
});
function we() {
  return this.rgb().formatHex();
}
function qi() {
  return this.rgb().formatHex8();
}
function Xi() {
  return on(this).formatHsl();
}
function _e() {
  return this.rgb().formatRgb();
}
function q(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = Di.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? be(e) : n === 3 ? new A(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? gt(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? gt(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = Hi.exec(t)) ? new A(e[1], e[2], e[3], 1) : (e = Bi.exec(t)) ? new A(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = Ii.exec(t)) ? gt(e[1], e[2], e[3], e[4]) : (e = Pi.exec(t)) ? gt(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = zi.exec(t)) ? ke(e[1], e[2] / 100, e[3] / 100, 1) : (e = Li.exec(t)) ? ke(e[1], e[2] / 100, e[3] / 100, e[4]) : xe.hasOwnProperty(t) ? be(xe[t]) : t === "transparent" ? new A(NaN, NaN, NaN, 0) : null;
}
function be(t) {
  return new A(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function gt(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new A(t, e, n, r);
}
function Vi(t) {
  return t instanceof ft || (t = q(t)), t ? (t = t.rgb(), new A(t.r, t.g, t.b, t.opacity)) : new A();
}
function Zt(t, e, n, r) {
  return arguments.length === 1 ? Vi(t) : new A(t, e, n, r ?? 1);
}
function A(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
le(A, Zt, rn(ft, {
  brighter(t) {
    return t = t == null ? Et : Math.pow(Et, t), new A(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? lt : Math.pow(lt, t), new A(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new A(L(this.r), L(this.g), L(this.b), St(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Ce,
  // Deprecated! Use color.formatHex.
  formatHex: Ce,
  formatHex8: Yi,
  formatRgb: Me,
  toString: Me
}));
function Ce() {
  return `#${z(this.r)}${z(this.g)}${z(this.b)}`;
}
function Yi() {
  return `#${z(this.r)}${z(this.g)}${z(this.b)}${z((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Me() {
  const t = St(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${L(this.r)}, ${L(this.g)}, ${L(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function St(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function L(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function z(t) {
  return t = L(t), (t < 16 ? "0" : "") + t.toString(16);
}
function ke(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new $(t, e, n, r);
}
function on(t) {
  if (t instanceof $) return new $(t.h, t.s, t.l, t.opacity);
  if (t instanceof ft || (t = q(t)), !t) return new $();
  if (t instanceof $) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), o = Math.max(e, n, r), a = NaN, l = o - i, s = (o + i) / 2;
  return l ? (e === o ? a = (n - r) / l + (n < r) * 6 : n === o ? a = (r - e) / l + 2 : a = (e - n) / l + 4, l /= s < 0.5 ? o + i : 2 - o - i, a *= 60) : l = s > 0 && s < 1 ? 0 : a, new $(a, l, s, t.opacity);
}
function Wi(t, e, n, r) {
  return arguments.length === 1 ? on(t) : new $(t, e, n, r ?? 1);
}
function $(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
le($, Wi, rn(ft, {
  brighter(t) {
    return t = t == null ? Et : Math.pow(Et, t), new $(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? lt : Math.pow(lt, t), new $(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new A(
      Vt(t >= 240 ? t - 240 : t + 120, i, r),
      Vt(t, i, r),
      Vt(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new $(Ne(this.h), vt(this.s), vt(this.l), St(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = St(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Ne(this.h)}, ${vt(this.s) * 100}%, ${vt(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Ne(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function vt(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function Vt(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const ue = (t) => () => t;
function Gi(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function Ui(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function Zi(t) {
  return (t = +t) == 1 ? an : function(e, n) {
    return n - e ? Ui(e, n, t) : ue(isNaN(e) ? n : e);
  };
}
function an(t, e) {
  var n = e - t;
  return n ? Gi(t, n) : ue(isNaN(t) ? e : t);
}
const $t = function t(e) {
  var n = Zi(e);
  function r(i, o) {
    var a = n((i = Zt(i)).r, (o = Zt(o)).r), l = n(i.g, o.g), s = n(i.b, o.b), u = an(i.opacity, o.opacity);
    return function(c) {
      return i.r = a(c), i.g = l(c), i.b = s(c), i.opacity = u(c), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function Ji(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i) r[i] = t[i] * (1 - o) + e[i] * o;
    return r;
  };
}
function Ki(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Qi(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a) i[a] = se(t[a], e[a]);
  for (; a < n; ++a) o[a] = e[a];
  return function(l) {
    for (a = 0; a < r; ++a) o[a] = i[a](l);
    return o;
  };
}
function ji(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function S(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function to(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = se(t[i], e[i]) : r[i] = e[i];
  return function(o) {
    for (i in n) r[i] = n[i](o);
    return r;
  };
}
var Jt = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Yt = new RegExp(Jt.source, "g");
function eo(t) {
  return function() {
    return t;
  };
}
function no(t) {
  return function(e) {
    return t(e) + "";
  };
}
function ln(t, e) {
  var n = Jt.lastIndex = Yt.lastIndex = 0, r, i, o, a = -1, l = [], s = [];
  for (t = t + "", e = e + ""; (r = Jt.exec(t)) && (i = Yt.exec(e)); )
    (o = i.index) > n && (o = e.slice(n, o), l[a] ? l[a] += o : l[++a] = o), (r = r[0]) === (i = i[0]) ? l[a] ? l[a] += i : l[++a] = i : (l[++a] = null, s.push({ i: a, x: S(r, i) })), n = Yt.lastIndex;
  return n < e.length && (o = e.slice(n), l[a] ? l[a] += o : l[++a] = o), l.length < 2 ? s[0] ? no(s[0].x) : eo(e) : (e = s.length, function(u) {
    for (var c = 0, h; c < e; ++c) l[(h = s[c]).i] = h.x(u);
    return l.join("");
  });
}
function se(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? ue(e) : (n === "number" ? S : n === "string" ? (r = q(e)) ? (e = r, $t) : ln : e instanceof q ? $t : e instanceof Date ? ji : Ki(e) ? Ji : Array.isArray(e) ? Qi : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? to : S)(t, e);
}
function ro(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var Ae = 180 / Math.PI, Kt = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function un(t, e, n, r, i, o) {
  var a, l, s;
  return (a = Math.sqrt(t * t + e * e)) && (t /= a, e /= a), (s = t * n + e * r) && (n -= t * s, r -= e * s), (l = Math.sqrt(n * n + r * r)) && (n /= l, r /= l, s /= l), t * r < e * n && (t = -t, e = -e, s = -s, a = -a), {
    translateX: i,
    translateY: o,
    rotate: Math.atan2(e, t) * Ae,
    skewX: Math.atan(s) * Ae,
    scaleX: a,
    scaleY: l
  };
}
var yt;
function io(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? Kt : un(e.a, e.b, e.c, e.d, e.e, e.f);
}
function oo(t) {
  return t == null || (yt || (yt = document.createElementNS("http://www.w3.org/2000/svg", "g")), yt.setAttribute("transform", t), !(t = yt.transform.baseVal.consolidate())) ? Kt : (t = t.matrix, un(t.a, t.b, t.c, t.d, t.e, t.f));
}
function sn(t, e, n, r) {
  function i(u) {
    return u.length ? u.pop() + " " : "";
  }
  function o(u, c, h, f, p, g) {
    if (u !== h || c !== f) {
      var v = p.push("translate(", null, e, null, n);
      g.push({ i: v - 4, x: S(u, h) }, { i: v - 2, x: S(c, f) });
    } else (h || f) && p.push("translate(" + h + e + f + n);
  }
  function a(u, c, h, f) {
    u !== c ? (u - c > 180 ? c += 360 : c - u > 180 && (u += 360), f.push({ i: h.push(i(h) + "rotate(", null, r) - 2, x: S(u, c) })) : c && h.push(i(h) + "rotate(" + c + r);
  }
  function l(u, c, h, f) {
    u !== c ? f.push({ i: h.push(i(h) + "skewX(", null, r) - 2, x: S(u, c) }) : c && h.push(i(h) + "skewX(" + c + r);
  }
  function s(u, c, h, f, p, g) {
    if (u !== h || c !== f) {
      var v = p.push(i(p) + "scale(", null, ",", null, ")");
      g.push({ i: v - 4, x: S(u, h) }, { i: v - 2, x: S(c, f) });
    } else (h !== 1 || f !== 1) && p.push(i(p) + "scale(" + h + "," + f + ")");
  }
  return function(u, c) {
    var h = [], f = [];
    return u = t(u), c = t(c), o(u.translateX, u.translateY, c.translateX, c.translateY, h, f), a(u.rotate, c.rotate, h, f), l(u.skewX, c.skewX, h, f), s(u.scaleX, u.scaleY, c.scaleX, c.scaleY, h, f), u = c = null, function(p) {
      for (var g = -1, v = f.length, d; ++g < v; ) h[(d = f[g]).i] = d.x(p);
      return h.join("");
    };
  };
}
var ao = sn(io, "px, ", "px)", "deg)"), lo = sn(oo, ", ", ")", ")"), K = 0, nt = 0, j = 0, cn = 1e3, Tt, rt, Rt = 0, X = 0, Pt = 0, st = typeof performance == "object" && performance.now ? performance : Date, fn = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function ce() {
  return X || (fn(uo), X = st.now() + Pt);
}
function uo() {
  X = 0;
}
function Ft() {
  this._call = this._time = this._next = null;
}
Ft.prototype = hn.prototype = {
  constructor: Ft,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? ce() : +n) + (e == null ? 0 : +e), !this._next && rt !== this && (rt ? rt._next = this : Tt = this, rt = this), this._call = t, this._time = n, Qt();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Qt());
  }
};
function hn(t, e, n) {
  var r = new Ft();
  return r.restart(t, e, n), r;
}
function so() {
  ce(), ++K;
  for (var t = Tt, e; t; )
    (e = X - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --K;
}
function Ee() {
  X = (Rt = st.now()) + Pt, K = nt = 0;
  try {
    so();
  } finally {
    K = 0, fo(), X = 0;
  }
}
function co() {
  var t = st.now(), e = t - Rt;
  e > cn && (Pt -= e, Rt = t);
}
function fo() {
  for (var t, e = Tt, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : Tt = n);
  rt = t, Qt(r);
}
function Qt(t) {
  if (!K) {
    nt && (nt = clearTimeout(nt));
    var e = t - X;
    e > 24 ? (t < 1 / 0 && (nt = setTimeout(Ee, t - st.now() - Pt)), j && (j = clearInterval(j))) : (j || (Rt = st.now(), j = setInterval(co, cn)), K = 1, fn(Ee));
  }
}
function Se(t, e, n) {
  var r = new Ft();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), t(i + e);
  }, e, n), r;
}
var ho = Ve("start", "end", "cancel", "interrupt"), po = [], dn = 0, $e = 1, jt = 2, Mt = 3, Te = 4, te = 5, kt = 6;
function zt(t, e, n, r, i, o) {
  var a = t.__transition;
  if (!a) t.__transition = {};
  else if (n in a) return;
  mo(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: ho,
    tween: po,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: dn
  });
}
function fe(t, e) {
  var n = T(t, e);
  if (n.state > dn) throw new Error("too late; already scheduled");
  return n;
}
function O(t, e) {
  var n = T(t, e);
  if (n.state > Mt) throw new Error("too late; already running");
  return n;
}
function T(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function mo(t, e, n) {
  var r = t.__transition, i;
  r[e] = n, n.timer = hn(o, 0, n.time);
  function o(u) {
    n.state = $e, n.timer.restart(a, n.delay, n.time), n.delay <= u && a(u - n.delay);
  }
  function a(u) {
    var c, h, f, p;
    if (n.state !== $e) return s();
    for (c in r)
      if (p = r[c], p.name === n.name) {
        if (p.state === Mt) return Se(a);
        p.state === Te ? (p.state = kt, p.timer.stop(), p.on.call("interrupt", t, t.__data__, p.index, p.group), delete r[c]) : +c < e && (p.state = kt, p.timer.stop(), p.on.call("cancel", t, t.__data__, p.index, p.group), delete r[c]);
      }
    if (Se(function() {
      n.state === Mt && (n.state = Te, n.timer.restart(l, n.delay, n.time), l(u));
    }), n.state = jt, n.on.call("start", t, t.__data__, n.index, n.group), n.state === jt) {
      for (n.state = Mt, i = new Array(f = n.tween.length), c = 0, h = -1; c < f; ++c)
        (p = n.tween[c].value.call(t, t.__data__, n.index, n.group)) && (i[++h] = p);
      i.length = h + 1;
    }
  }
  function l(u) {
    for (var c = u < n.duration ? n.ease.call(null, u / n.duration) : (n.timer.restart(s), n.state = te, 1), h = -1, f = i.length; ++h < f; )
      i[h].call(t, c);
    n.state === te && (n.on.call("end", t, t.__data__, n.index, n.group), s());
  }
  function s() {
    n.state = kt, n.timer.stop(), delete r[e];
    for (var u in r) return;
    delete t.__transition;
  }
}
function go(t, e) {
  var n = t.__transition, r, i, o = !0, a;
  if (n) {
    e = e == null ? null : e + "";
    for (a in n) {
      if ((r = n[a]).name !== e) {
        o = !1;
        continue;
      }
      i = r.state > jt && r.state < te, r.state = kt, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[a];
    }
    o && delete t.__transition;
  }
}
function vo(t) {
  return this.each(function() {
    go(this, t);
  });
}
function yo(t, e) {
  var n, r;
  return function() {
    var i = O(this, t), o = i.tween;
    if (o !== n) {
      r = n = o;
      for (var a = 0, l = r.length; a < l; ++a)
        if (r[a].name === e) {
          r = r.slice(), r.splice(a, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function xo(t, e, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var o = O(this, t), a = o.tween;
    if (a !== r) {
      i = (r = a).slice();
      for (var l = { name: e, value: n }, s = 0, u = i.length; s < u; ++s)
        if (i[s].name === e) {
          i[s] = l;
          break;
        }
      s === u && i.push(l);
    }
    o.tween = i;
  };
}
function wo(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = T(this.node(), n).tween, i = 0, o = r.length, a; i < o; ++i)
      if ((a = r[i]).name === t)
        return a.value;
    return null;
  }
  return this.each((e == null ? yo : xo)(n, t, e));
}
function he(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var i = O(this, r);
    (i.value || (i.value = {}))[e] = n.apply(this, arguments);
  }), function(i) {
    return T(i, r).value[e];
  };
}
function pn(t, e) {
  var n;
  return (typeof e == "number" ? S : e instanceof q ? $t : (n = q(e)) ? (e = n, $t) : ln)(t, e);
}
function _o(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function bo(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Co(t, e, n) {
  var r, i = n + "", o;
  return function() {
    var a = this.getAttribute(t);
    return a === i ? null : a === r ? o : o = e(r = a, n);
  };
}
function Mo(t, e, n) {
  var r, i = n + "", o;
  return function() {
    var a = this.getAttributeNS(t.space, t.local);
    return a === i ? null : a === r ? o : o = e(r = a, n);
  };
}
function ko(t, e, n) {
  var r, i, o;
  return function() {
    var a, l = n(this), s;
    return l == null ? void this.removeAttribute(t) : (a = this.getAttribute(t), s = l + "", a === s ? null : a === r && s === i ? o : (i = s, o = e(r = a, l)));
  };
}
function No(t, e, n) {
  var r, i, o;
  return function() {
    var a, l = n(this), s;
    return l == null ? void this.removeAttributeNS(t.space, t.local) : (a = this.getAttributeNS(t.space, t.local), s = l + "", a === s ? null : a === r && s === i ? o : (i = s, o = e(r = a, l)));
  };
}
function Ao(t, e) {
  var n = It(t), r = n === "transform" ? lo : pn;
  return this.attrTween(t, typeof e == "function" ? (n.local ? No : ko)(n, r, he(this, "attr." + t, e)) : e == null ? (n.local ? bo : _o)(n) : (n.local ? Mo : Co)(n, r, e));
}
function Eo(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function So(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function $o(t, e) {
  var n, r;
  function i() {
    var o = e.apply(this, arguments);
    return o !== r && (n = (r = o) && So(t, o)), n;
  }
  return i._value = e, i;
}
function To(t, e) {
  var n, r;
  function i() {
    var o = e.apply(this, arguments);
    return o !== r && (n = (r = o) && Eo(t, o)), n;
  }
  return i._value = e, i;
}
function Ro(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = It(t);
  return this.tween(n, (r.local ? $o : To)(r, e));
}
function Fo(t, e) {
  return function() {
    fe(this, t).delay = +e.apply(this, arguments);
  };
}
function Oo(t, e) {
  return e = +e, function() {
    fe(this, t).delay = e;
  };
}
function Do(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Fo : Oo)(e, t)) : T(this.node(), e).delay;
}
function Ho(t, e) {
  return function() {
    O(this, t).duration = +e.apply(this, arguments);
  };
}
function Bo(t, e) {
  return e = +e, function() {
    O(this, t).duration = e;
  };
}
function Io(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Ho : Bo)(e, t)) : T(this.node(), e).duration;
}
function Po(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    O(this, t).ease = e;
  };
}
function zo(t) {
  var e = this._id;
  return arguments.length ? this.each(Po(e, t)) : T(this.node(), e).ease;
}
function Lo(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    O(this, t).ease = n;
  };
}
function qo(t) {
  if (typeof t != "function") throw new Error();
  return this.each(Lo(this._id, t));
}
function Xo(t) {
  typeof t != "function" && (t = Ue(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = e[i], a = o.length, l = r[i] = [], s, u = 0; u < a; ++u)
      (s = o[u]) && t.call(s, s.__data__, u, o) && l.push(s);
  return new B(r, this._parents, this._name, this._id);
}
function Vo(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, i = n.length, o = Math.min(r, i), a = new Array(r), l = 0; l < o; ++l)
    for (var s = e[l], u = n[l], c = s.length, h = a[l] = new Array(c), f, p = 0; p < c; ++p)
      (f = s[p] || u[p]) && (h[p] = f);
  for (; l < r; ++l)
    a[l] = e[l];
  return new B(a, this._parents, this._name, this._id);
}
function Yo(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function Wo(t, e, n) {
  var r, i, o = Yo(e) ? fe : O;
  return function() {
    var a = o(this, t), l = a.on;
    l !== r && (i = (r = l).copy()).on(e, n), a.on = i;
  };
}
function Go(t, e) {
  var n = this._id;
  return arguments.length < 2 ? T(this.node(), n).on.on(t) : this.each(Wo(n, t, e));
}
function Uo(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function Zo() {
  return this.on("end.remove", Uo(this._id));
}
function Jo(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = ie(t));
  for (var r = this._groups, i = r.length, o = new Array(i), a = 0; a < i; ++a)
    for (var l = r[a], s = l.length, u = o[a] = new Array(s), c, h, f = 0; f < s; ++f)
      (c = l[f]) && (h = t.call(c, c.__data__, f, l)) && ("__data__" in c && (h.__data__ = c.__data__), u[f] = h, zt(u[f], e, n, f, u, T(c, n)));
  return new B(o, this._parents, e, n);
}
function Ko(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = Ge(t));
  for (var r = this._groups, i = r.length, o = [], a = [], l = 0; l < i; ++l)
    for (var s = r[l], u = s.length, c, h = 0; h < u; ++h)
      if (c = s[h]) {
        for (var f = t.call(c, c.__data__, h, s), p, g = T(c, n), v = 0, d = f.length; v < d; ++v)
          (p = f[v]) && zt(p, e, n, v, f, g);
        o.push(f), a.push(c);
      }
  return new B(o, a, e, n);
}
var Qo = ct.prototype.constructor;
function jo() {
  return new Qo(this._groups, this._parents);
}
function ta(t, e) {
  var n, r, i;
  return function() {
    var o = J(this, t), a = (this.style.removeProperty(t), J(this, t));
    return o === a ? null : o === n && a === r ? i : i = e(n = o, r = a);
  };
}
function mn(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function ea(t, e, n) {
  var r, i = n + "", o;
  return function() {
    var a = J(this, t);
    return a === i ? null : a === r ? o : o = e(r = a, n);
  };
}
function na(t, e, n) {
  var r, i, o;
  return function() {
    var a = J(this, t), l = n(this), s = l + "";
    return l == null && (s = l = (this.style.removeProperty(t), J(this, t))), a === s ? null : a === r && s === i ? o : (i = s, o = e(r = a, l));
  };
}
function ra(t, e) {
  var n, r, i, o = "style." + e, a = "end." + o, l;
  return function() {
    var s = O(this, t), u = s.on, c = s.value[o] == null ? l || (l = mn(e)) : void 0;
    (u !== n || i !== c) && (r = (n = u).copy()).on(a, i = c), s.on = r;
  };
}
function ia(t, e, n) {
  var r = (t += "") == "transform" ? ao : pn;
  return e == null ? this.styleTween(t, ta(t, r)).on("end.style." + t, mn(t)) : typeof e == "function" ? this.styleTween(t, na(t, r, he(this, "style." + t, e))).each(ra(this._id, t)) : this.styleTween(t, ea(t, r, e), n).on("end.style." + t, null);
}
function oa(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function aa(t, e, n) {
  var r, i;
  function o() {
    var a = e.apply(this, arguments);
    return a !== i && (r = (i = a) && oa(t, a, n)), r;
  }
  return o._value = e, o;
}
function la(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, aa(t, e, n ?? ""));
}
function ua(t) {
  return function() {
    this.textContent = t;
  };
}
function sa(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function ca(t) {
  return this.tween("text", typeof t == "function" ? sa(he(this, "text", t)) : ua(t == null ? "" : t + ""));
}
function fa(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function ha(t) {
  var e, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (e = (n = i) && fa(i)), e;
  }
  return r._value = t, r;
}
function da(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, ha(t));
}
function pa() {
  for (var t = this._name, e = this._id, n = gn(), r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var a = r[o], l = a.length, s, u = 0; u < l; ++u)
      if (s = a[u]) {
        var c = T(s, e);
        zt(s, t, n, u, a, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new B(r, this._parents, t, n);
}
function ma() {
  var t, e, n = this, r = n._id, i = n.size();
  return new Promise(function(o, a) {
    var l = { value: a }, s = { value: function() {
      --i === 0 && o();
    } };
    n.each(function() {
      var u = O(this, r), c = u.on;
      c !== t && (e = (t = c).copy(), e._.cancel.push(l), e._.interrupt.push(l), e._.end.push(s)), u.on = e;
    }), i === 0 && o();
  });
}
var ga = 0;
function B(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function gn() {
  return ++ga;
}
var H = ct.prototype;
B.prototype = {
  constructor: B,
  select: Jo,
  selectAll: Ko,
  selectChild: H.selectChild,
  selectChildren: H.selectChildren,
  filter: Xo,
  merge: Vo,
  selection: jo,
  transition: pa,
  call: H.call,
  nodes: H.nodes,
  node: H.node,
  size: H.size,
  empty: H.empty,
  each: H.each,
  on: Go,
  attr: Ao,
  attrTween: Ro,
  style: ia,
  styleTween: la,
  text: ca,
  textTween: da,
  remove: Zo,
  tween: wo,
  delay: Do,
  duration: Io,
  ease: zo,
  easeVarying: qo,
  end: ma,
  [Symbol.iterator]: H[Symbol.iterator]
};
function va(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var ya = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: va
};
function xa(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function wa(t) {
  var e, n;
  t instanceof B ? (e = t._id, t = t._name) : (e = gn(), (n = ya).time = ce(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var a = r[o], l = a.length, s, u = 0; u < l; ++u)
      (s = a[u]) && zt(s, t, e, u, a, n || xa(s, e));
  return new B(r, this._parents, t, e);
}
ct.prototype.interrupt = vo;
ct.prototype.transition = wa;
function _a(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function Ot(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function Q(t) {
  return t = Ot(Math.abs(t)), t ? t[1] : NaN;
}
function ba(t, e) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, l = t[0], s = 0; i > 0 && l > 0 && (s + l + 1 > r && (l = Math.max(1, r - s)), o.push(n.substring(i -= l, i + l)), !((s += l + 1) > r)); )
      l = t[a = (a + 1) % t.length];
    return o.reverse().join(e);
  };
}
function Ca(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var Ma = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Dt(t) {
  if (!(e = Ma.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new de({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
Dt.prototype = de.prototype;
function de(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
de.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function ka(t) {
  t: for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
    switch (t[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+t[n]) break t;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var vn;
function Na(t, e) {
  var n = Ot(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1], o = i - (vn = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + Ot(t, Math.max(0, e + o - 1))[0];
}
function Re(t, e) {
  var n = Ot(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Fe = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: _a,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Re(t * 100, e),
  r: Re,
  s: Na,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function Oe(t) {
  return t;
}
var De = Array.prototype.map, He = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Aa(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? Oe : ba(De.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", o = t.numerals === void 0 ? Oe : Ca(De.call(t.numerals, String)), a = t.percent === void 0 ? "%" : t.percent + "", l = t.minus === void 0 ? "−" : t.minus + "", s = t.nan === void 0 ? "NaN" : t.nan + "";
  function u(h) {
    h = Dt(h);
    var f = h.fill, p = h.align, g = h.sign, v = h.symbol, d = h.zero, m = h.width, w = h.comma, _ = h.precision, C = h.trim, b = h.type;
    b === "n" ? (w = !0, b = "g") : Fe[b] || (_ === void 0 && (_ = 12), C = !0, b = "g"), (d || f === "0" && p === "=") && (d = !0, f = "0", p = "=");
    var R = v === "$" ? n : v === "#" && /[boxX]/.test(b) ? "0" + b.toLowerCase() : "", Lt = v === "$" ? r : /[%p]/.test(b) ? a : "", ht = Fe[b], qt = /[defgprs%]/.test(b);
    _ = _ === void 0 ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
    function dt(x) {
      var I = R, y = Lt, M, V, P;
      if (b === "c")
        y = ht(x) + y, x = "";
      else {
        x = +x;
        var pt = x < 0 || 1 / x < 0;
        if (x = isNaN(x) ? s : ht(Math.abs(x), _), C && (x = ka(x)), pt && +x == 0 && g !== "+" && (pt = !1), I = (pt ? g === "(" ? g : l : g === "-" || g === "(" ? "" : g) + I, y = (b === "s" ? He[8 + vn / 3] : "") + y + (pt && g === "(" ? ")" : ""), qt) {
          for (M = -1, V = x.length; ++M < V; )
            if (P = x.charCodeAt(M), 48 > P || P > 57) {
              y = (P === 46 ? i + x.slice(M + 1) : x.slice(M)) + y, x = x.slice(0, M);
              break;
            }
        }
      }
      w && !d && (x = e(x, 1 / 0));
      var mt = I.length + x.length + y.length, D = mt < m ? new Array(m - mt + 1).join(f) : "";
      switch (w && d && (x = e(D + x, D.length ? m - y.length : 1 / 0), D = ""), p) {
        case "<":
          x = I + x + y + D;
          break;
        case "=":
          x = I + D + x + y;
          break;
        case "^":
          x = D.slice(0, mt = D.length >> 1) + I + x + y + D.slice(mt);
          break;
        default:
          x = D + I + x + y;
          break;
      }
      return o(x);
    }
    return dt.toString = function() {
      return h + "";
    }, dt;
  }
  function c(h, f) {
    var p = u((h = Dt(h), h.type = "f", h)), g = Math.max(-8, Math.min(8, Math.floor(Q(f) / 3))) * 3, v = Math.pow(10, -g), d = He[8 + g / 3];
    return function(m) {
      return p(v * m) + d;
    };
  }
  return {
    format: u,
    formatPrefix: c
  };
}
var xt, yn, xn;
Ea({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Ea(t) {
  return xt = Aa(t), yn = xt.format, xn = xt.formatPrefix, xt;
}
function Sa(t) {
  return Math.max(0, -Q(Math.abs(t)));
}
function $a(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Q(e) / 3))) * 3 - Q(Math.abs(t)));
}
function Ta(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Q(e) - Q(t)) + 1;
}
function Ra(t) {
  var e = 0, n = t.children, r = n && n.length;
  if (!r) e = 1;
  else for (; --r >= 0; ) e += n[r].value;
  t.value = e;
}
function Fa() {
  return this.eachAfter(Ra);
}
function Oa(t, e) {
  let n = -1;
  for (const r of this)
    t.call(e, r, ++n, this);
  return this;
}
function Da(t, e) {
  for (var n = this, r = [n], i, o, a = -1; n = r.pop(); )
    if (t.call(e, n, ++a, this), i = n.children)
      for (o = i.length - 1; o >= 0; --o)
        r.push(i[o]);
  return this;
}
function Ha(t, e) {
  for (var n = this, r = [n], i = [], o, a, l, s = -1; n = r.pop(); )
    if (i.push(n), o = n.children)
      for (a = 0, l = o.length; a < l; ++a)
        r.push(o[a]);
  for (; n = i.pop(); )
    t.call(e, n, ++s, this);
  return this;
}
function Ba(t, e) {
  let n = -1;
  for (const r of this)
    if (t.call(e, r, ++n, this))
      return r;
}
function Ia(t) {
  return this.eachAfter(function(e) {
    for (var n = +t(e.data) || 0, r = e.children, i = r && r.length; --i >= 0; ) n += r[i].value;
    e.value = n;
  });
}
function Pa(t) {
  return this.eachBefore(function(e) {
    e.children && e.children.sort(t);
  });
}
function za(t) {
  for (var e = this, n = La(e, t), r = [e]; e !== n; )
    e = e.parent, r.push(e);
  for (var i = r.length; t !== n; )
    r.splice(i, 0, t), t = t.parent;
  return r;
}
function La(t, e) {
  if (t === e) return t;
  var n = t.ancestors(), r = e.ancestors(), i = null;
  for (t = n.pop(), e = r.pop(); t === e; )
    i = t, t = n.pop(), e = r.pop();
  return i;
}
function qa() {
  for (var t = this, e = [t]; t = t.parent; )
    e.push(t);
  return e;
}
function Xa() {
  return Array.from(this);
}
function Va() {
  var t = [];
  return this.eachBefore(function(e) {
    e.children || t.push(e);
  }), t;
}
function Ya() {
  var t = this, e = [];
  return t.each(function(n) {
    n !== t && e.push({ source: n.parent, target: n });
  }), e;
}
function* Wa() {
  var t = this, e, n = [t], r, i, o;
  do
    for (e = n.reverse(), n = []; t = e.pop(); )
      if (yield t, r = t.children)
        for (i = 0, o = r.length; i < o; ++i)
          n.push(r[i]);
  while (n.length);
}
function pe(t, e) {
  t instanceof Map ? (t = [void 0, t], e === void 0 && (e = Za)) : e === void 0 && (e = Ua);
  for (var n = new Ht(t), r, i = [n], o, a, l, s; r = i.pop(); )
    if ((a = e(r.data)) && (s = (a = Array.from(a)).length))
      for (r.children = a, l = s - 1; l >= 0; --l)
        i.push(o = a[l] = new Ht(a[l])), o.parent = r, o.depth = r.depth + 1;
  return n.eachBefore(Ka);
}
function Ga() {
  return pe(this).eachBefore(Ja);
}
function Ua(t) {
  return t.children;
}
function Za(t) {
  return Array.isArray(t) ? t[1] : null;
}
function Ja(t) {
  t.data.value !== void 0 && (t.value = t.data.value), t.data = t.data.data;
}
function Ka(t) {
  var e = 0;
  do
    t.height = e;
  while ((t = t.parent) && t.height < ++e);
}
function Ht(t) {
  this.data = t, this.depth = this.height = 0, this.parent = null;
}
Ht.prototype = pe.prototype = {
  constructor: Ht,
  count: Fa,
  each: Oa,
  eachAfter: Ha,
  eachBefore: Da,
  find: Ba,
  sum: Ia,
  sort: Pa,
  path: za,
  ancestors: qa,
  descendants: Xa,
  leaves: Va,
  links: Ya,
  copy: Ga,
  [Symbol.iterator]: Wa
};
function Qa(t) {
  if (typeof t != "function") throw new Error();
  return t;
}
function tt() {
  return 0;
}
function et(t) {
  return function() {
    return t;
  };
}
function ja(t) {
  t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
}
function tl(t, e, n, r, i) {
  for (var o = t.children, a, l = -1, s = o.length, u = t.value && (r - e) / t.value; ++l < s; )
    a = o[l], a.y0 = n, a.y1 = i, a.x0 = e, a.x1 = e += a.value * u;
}
function el(t, e, n, r, i) {
  for (var o = t.children, a, l = -1, s = o.length, u = t.value && (i - n) / t.value; ++l < s; )
    a = o[l], a.x0 = e, a.x1 = r, a.y0 = n, a.y1 = n += a.value * u;
}
var nl = (1 + Math.sqrt(5)) / 2;
function rl(t, e, n, r, i, o) {
  for (var a = [], l = e.children, s, u, c = 0, h = 0, f = l.length, p, g, v = e.value, d, m, w, _, C, b, R; c < f; ) {
    p = i - n, g = o - r;
    do
      d = l[h++].value;
    while (!d && h < f);
    for (m = w = d, b = Math.max(g / p, p / g) / (v * t), R = d * d * b, C = Math.max(w / R, R / m); h < f; ++h) {
      if (d += u = l[h].value, u < m && (m = u), u > w && (w = u), R = d * d * b, _ = Math.max(w / R, R / m), _ > C) {
        d -= u;
        break;
      }
      C = _;
    }
    a.push(s = { value: d, dice: p < g, children: l.slice(c, h) }), s.dice ? tl(s, n, r, i, v ? r += g * d / v : o) : el(s, n, r, v ? n += p * d / v : i, o), v -= d, c = h;
  }
  return a;
}
const wn = function t(e) {
  function n(r, i, o, a, l) {
    rl(e, r, i, o, a, l);
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(nl);
function il() {
  var t = wn, e = !1, n = 1, r = 1, i = [0], o = tt, a = tt, l = tt, s = tt, u = tt;
  function c(f) {
    return f.x0 = f.y0 = 0, f.x1 = n, f.y1 = r, f.eachBefore(h), i = [0], e && f.eachBefore(ja), f;
  }
  function h(f) {
    var p = i[f.depth], g = f.x0 + p, v = f.y0 + p, d = f.x1 - p, m = f.y1 - p;
    d < g && (g = d = (g + d) / 2), m < v && (v = m = (v + m) / 2), f.x0 = g, f.y0 = v, f.x1 = d, f.y1 = m, f.children && (p = i[f.depth + 1] = o(f) / 2, g += u(f) - p, v += a(f) - p, d -= l(f) - p, m -= s(f) - p, d < g && (g = d = (g + d) / 2), m < v && (v = m = (v + m) / 2), t(f, g, v, d, m));
  }
  return c.round = function(f) {
    return arguments.length ? (e = !!f, c) : e;
  }, c.size = function(f) {
    return arguments.length ? (n = +f[0], r = +f[1], c) : [n, r];
  }, c.tile = function(f) {
    return arguments.length ? (t = Qa(f), c) : t;
  }, c.padding = function(f) {
    return arguments.length ? c.paddingInner(f).paddingOuter(f) : c.paddingInner();
  }, c.paddingInner = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : et(+f), c) : o;
  }, c.paddingOuter = function(f) {
    return arguments.length ? c.paddingTop(f).paddingRight(f).paddingBottom(f).paddingLeft(f) : c.paddingTop();
  }, c.paddingTop = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : et(+f), c) : a;
  }, c.paddingRight = function(f) {
    return arguments.length ? (l = typeof f == "function" ? f : et(+f), c) : l;
  }, c.paddingBottom = function(f) {
    return arguments.length ? (s = typeof f == "function" ? f : et(+f), c) : s;
  }, c.paddingLeft = function(f) {
    return arguments.length ? (u = typeof f == "function" ? f : et(+f), c) : u;
  }, c;
}
function ol(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function al(t) {
  return function() {
    return t;
  };
}
function ll(t) {
  return +t;
}
var Be = [0, 1];
function G(t) {
  return t;
}
function ee(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : al(isNaN(e) ? NaN : 0.5);
}
function ul(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function sl(t, e, n) {
  var r = t[0], i = t[1], o = e[0], a = e[1];
  return i < r ? (r = ee(i, r), o = n(a, o)) : (r = ee(r, i), o = n(o, a)), function(l) {
    return o(r(l));
  };
}
function cl(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++a < r; )
    i[a] = ee(t[a], t[a + 1]), o[a] = n(e[a], e[a + 1]);
  return function(l) {
    var s = Un(t, l, 1, r) - 1;
    return o[s](i[s](l));
  };
}
function fl(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function hl() {
  var t = Be, e = Be, n = se, r, i, o, a = G, l, s, u;
  function c() {
    var f = Math.min(t.length, e.length);
    return a !== G && (a = ul(t[0], t[f - 1])), l = f > 2 ? cl : sl, s = u = null, h;
  }
  function h(f) {
    return f == null || isNaN(f = +f) ? o : (s || (s = l(t.map(r), e, n)))(r(a(f)));
  }
  return h.invert = function(f) {
    return a(i((u || (u = l(e, t.map(r), S)))(f)));
  }, h.domain = function(f) {
    return arguments.length ? (t = Array.from(f, ll), c()) : t.slice();
  }, h.range = function(f) {
    return arguments.length ? (e = Array.from(f), c()) : e.slice();
  }, h.rangeRound = function(f) {
    return e = Array.from(f), n = ro, c();
  }, h.clamp = function(f) {
    return arguments.length ? (a = f ? !0 : G, c()) : a !== G;
  }, h.interpolate = function(f) {
    return arguments.length ? (n = f, c()) : n;
  }, h.unknown = function(f) {
    return arguments.length ? (o = f, h) : o;
  }, function(f, p) {
    return r = f, i = p, c();
  };
}
function dl() {
  return hl()(G, G);
}
function pl(t, e, n, r) {
  var i = jn(t, e, n), o;
  switch (r = Dt(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(o = $a(i, a)) && (r.precision = o), xn(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = Ta(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = Sa(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return yn(r);
}
function ml(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return Qn(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return pl(i[0], i[i.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, o = r.length - 1, a = r[i], l = r[o], s, u, c = 10;
    for (l < a && (u = a, a = l, l = u, u = i, i = o, o = u); c-- > 0; ) {
      if (u = Wt(a, l, n), u === s)
        return r[i] = a, r[o] = l, e(r);
      if (u > 0)
        a = Math.floor(a / u) * u, l = Math.ceil(l / u) * u;
      else if (u < 0)
        a = Math.ceil(a * u) / u, l = Math.floor(l * u) / u;
      else
        break;
      s = u;
    }
    return t;
  }, t;
}
function it() {
  var t = dl();
  return t.copy = function() {
    return fl(t, it());
  }, ol.apply(t, arguments), ml(t);
}
function ot(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
ot.prototype = {
  constructor: ot,
  scale: function(t) {
    return t === 1 ? this : new ot(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new ot(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
ot.prototype;
const wt = {
  light: {
    "-5": { bgColor: "#EA3948", fontColor: "#fff" },
    "-4": { bgColor: "#F5747F", fontColor: "#440B10" },
    "-3": { bgColor: "#FAA7AE", fontColor: "#440B10" },
    "-2": { bgColor: "#FDCBCF", fontColor: "#440B10" },
    "-1": { bgColor: "#FDE3E5", fontColor: "#440B10" },
    0: { bgColor: "#F2F2F2", fontColor: "#000" },
    1: { bgColor: "#CCF5E0", fontColor: "#062D1A" },
    2: { bgColor: "#99EBC0", fontColor: "#062D1A" },
    3: { bgColor: "#7FE6B0", fontColor: "#062D1A" },
    4: { bgColor: "#4CDC91", fontColor: "#062D1A" },
    5: { bgColor: "#24C371", fontColor: "#fff" }
  },
  dark: {
    "-5": { bgColor: "#EA3948", fontColor: "#fff" },
    "-4": { bgColor: "#D82A39", fontColor: "#fff" },
    "-3": { bgColor: "#B61F2C", fontColor: "#fff" },
    "-2": { bgColor: "#961E28", fontColor: "#fff" },
    "-1": { bgColor: "#7D1F27", fontColor: "#fff" },
    0: { bgColor: "#2E2E2E", fontColor: "#fff" },
    1: { bgColor: "#155234", fontColor: "#fff" },
    2: { bgColor: "#17643D", fontColor: "#fff" },
    3: { bgColor: "#167B47", fontColor: "#fff" },
    4: { bgColor: "#18A15A", fontColor: "#fff" },
    5: { bgColor: "#24C371", fontColor: "#fff" }
  }
}, Y = {
  light: {
    bgColor: "#FFFFFF",
    selectedColor: "#FABD26",
    headerColor: "#FFFFFF"
  },
  dark: {
    bgColor: "#252525",
    selectedColor: "#E1A30C",
    headerColor: "#191919"
  }
}, gl = 44, Ie = 4, _t = 160, Pe = {
  "-4": { min: -1 / 0, max: -4 },
  "-3": { min: -4, max: -3 },
  "-2": { min: -3, max: -2 },
  "-1": { min: -2, max: -1 },
  0: { min: -1, max: 1 },
  "+1": {
    min: 1,
    max: 2
  },
  "+2": { min: 2, max: 3 },
  "+3": { min: 3, max: 4 },
  "+4": {
    min: 4,
    max: 1 / 0
  }
};
function Bt({ element: t, node: e, color: n }) {
  const r = t.select ? t : Ut(t);
  r.select("rect").style("fill", n), r.select("body").style("background-color", n), Oi(".repo-mmap-cell.repo-mmap-child").filter((i) => i.parent === e).select("rect").style("stroke", n);
}
function ne(t, e = !1) {
  const n = e ? "dark" : "light";
  if (t === 0)
    return wt[n][t];
  const r = t > 0 ? Math.ceil(t) : Math.floor(t);
  return r < -5 ? wt[n][-5] : r > 5 ? wt[n][5] : wt[n][r];
}
function vl({
  chartWrapper: t,
  chartConfig: e,
  isHovered: n,
  darkMode: r
}) {
  const i = k(), o = k(), a = () => t.value.selectAll("g.repo-mmap-cell.repo-mmap-parent").data(
    [
      e.value.rootNode,
      ...e.value.rootNode.children || []
    ],
    (d) => "p-" + d.data.name
  ), l = () => i.value.enter().append("g").attr("class", "repo-mmap-cell repo-mmap-parent"), s = () => {
    o.value.on(
      "click",
      (d, m) => e.value.zoom(
        e.value.node === m.parent ? m : m.parent
      )
    );
  }, u = () => {
    o.value.on("mouseover", function(d, m) {
      Bt({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        element: this,
        node: m,
        color: e.value.selectedColor
      });
    });
  }, c = () => {
    o.value.on("mouseout", function(d, m) {
      Bt({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        element: this,
        node: m,
        color: e.value.backgroundColor
      }), n.value = !1;
    });
  }, h = () => {
    s(), u(), c();
  }, f = () => {
    o.value.append("rect").attr("width", (d) => Math.max(0.01, d.x1 - d.x0)).attr("height", (d) => d.y1 - d.y0).style("fill", e.value.headerColor).style("stroke", e.value.backgroundColor);
  }, p = () => {
    o.value.append("foreignObject").attr("class", "foreignObject").attr("width", (d) => Math.max(0.01, d.x1 - d.x0)).attr("height", e.value.headerHeight).style("padding", "0px 2px 0px 1px").append("xhtml:body").attr("class", "repo-mmap-labelbody").style("margin", "0").style("color", r ? "#fff" : "#000").append("div").attr("class", "repo-mmap-label"), o.value.select(".foreignObject").select(".repo-mmap-labelbody").style("background-color", () => e.value.backgroundColor).select(".repo-mmap-label").style("height", e.value.headerHeight - 1 + "px").text((d) => d.x1 - d.x0 < 40 ? "" : d.data.name);
  }, g = () => {
    o.value.select(".repo-mmap-cell").attr(
      "transform",
      (d) => `translate(${e.value.xscale(d.x1)},${e.value.yscale(d.y0)})`
    );
  };
  return { processParentCells: () => {
    i.value = a(), o.value = l(), h(), f(), p(), o.value.transition().duration(e.value.transitionDuration), g(), i.value.exit().remove();
  } };
}
function yl({
  chartWrapper: t,
  chartConfig: e,
  isHovered: n,
  darkMode: r,
  onClickCallback: i,
  routeCallback: o,
  hoverDebounce: a,
  hoveredNodeData: l,
  hoveredComponentHeight: s,
  hoveredComponentWidth: u,
  preview: c
}) {
  const h = k(), f = k(), p = k(), g = k(), v = kn({
    top: "",
    bottom: "",
    left: ""
  }), d = () => t.value.selectAll("g.repo-mmap-cell.repo-mmap-child").data(e.value.rootNode.leaves(), (y) => "c-" + y.data.name), m = () => p.value.enter().append("g").attr("class", "repo-mmap-cell repo-mmap-child"), w = () => {
    g.value.on("click", (y, M) => {
      y.detail === 1 && (f.value = setTimeout(function() {
        i && M.data ? i(M.data) : e.value.zoom(
          e.value.node === M.parent ? e.value.node.parent : M.parent
        );
      }, 300));
    });
  }, _ = () => {
    g.value.on("dblclick", (y, M) => {
      o && M.data.isin && (clearTimeout(Number(f.value)), o(M.data));
    });
  }, C = () => {
    g.value.on("mouseover", (y, M) => {
      clearTimeout(Number(h.value)), h.value = setTimeout(() => {
        n.value = !0;
      }, a);
      const V = t.value.selectAll(".repo-mmap-cell.repo-mmap-parent").filter((P) => M.parent === P);
      Bt({
        element: V,
        node: M.parent,
        color: e.value.selectedColor
      }), l.value = M.data;
    });
  }, b = () => {
    g.value.on("mousemove", (y) => {
      c !== "empty" && (document.body.clientHeight - y.pageY > Number(s) ? (v.top = `${y.pageY}px`, v.bottom = "auto") : (v.top = "auto", v.bottom = `${gl}px`), y.pageX > document.body.clientWidth / 2 ? y.pageX - Number(u) - _t < 0 ? v.left = `${Ie}px` : v.left = `${y.pageX - Number(u) - _t}px` : y.pageX + _t + Number(u) > document.body.clientWidth ? v.left = `${document.body.clientWidth - Number(u) - Ie}px` : v.left = `${y.pageX + _t}px`);
    });
  }, R = () => {
    g.value.on("mouseout", (y, M) => {
      clearTimeout(Number(h.value));
      const V = t.value.selectAll(".repo-mmap-cell.repo-mmap-parent").filter((P) => P === M.parent);
      Bt({
        element: V,
        node: M.parent,
        color: e.value.backgroundColor
      });
    });
  }, Lt = () => {
    w(), _(), C(), b(), R();
  }, ht = () => {
    g.value.append("rect").style("fill", (y) => ne(y.data.percent, r).bgColor).style("stroke", e.value.backgroundColor).attr("width", (y) => Math.max(0.01, y.x1 - y.x0)).attr("height", (y) => Math.max(0.01, y.y1 - y.y0));
  }, qt = () => {
    g.value.append("foreignObject").attr("class", "foreignObject").attr("width", (y) => Math.max(0.01, y.x1 - y.x0)).attr("height", (y) => Math.max(0.01, y.y1 - y.y0)).style("color", (y) => ne(y.data.percent, r).fontColor).append("xhtml:body").attr("class", "repo-mmap-labelbody");
  }, dt = () => {
    g.value.select(".repo-mmap-labelbody").append("div").attr("class", "repo-mmap-label").text((y) => y.data.name).append("div").attr("class", "repo-mmap-labelp").text((y) => y.data.percent + "%");
  }, x = () => {
    g.value.select(".repo-mmap-cell").attr(
      "transform",
      (y) => `translate(${e.value.xscale(y.x0)},${e.value.yscale(y.y0)})`
    );
  };
  return { style: v, processChildrenCells: () => {
    p.value = d(), g.value = m(), Lt(), ht(), qt(), dt(), g.value.transition().duration(e.value.transitionDuration), x(), p.value.exit().remove();
  } };
}
function xl({
  chartWrapper: t,
  chartConfig: e,
  chartWidth: n,
  chartHeight: r,
  darkMode: i
}) {
  const o = k(), a = Z(
    () => Number(E(n)) / (o.value.x1 - o.value.x0)
  ), l = Z(
    () => Number(E(r)) / (o.value.y1 - o.value.y0)
  ), s = (d) => a.value * (d.x1 - d.x0), u = (d) => l.value * (d.y1 - d.y0), c = () => t.value.selectAll("g.repo-mmap-cell").transition().duration(e.value.transitionDuration).attr(
    "transform",
    (d) => `translate(${e.value.xscale(d.x0)},${e.value.yscale(d.y0)})`
  ), h = () => {
    t.value.selectAll(
      ".repo-mmap-cell.repo-mmap-parent .foreignObject .repo-mmap-label"
    ).text((d) => s(d) < 20 ? "" : d.data.name);
  }, f = () => {
    const d = t.value.selectAll(".repo-mmap-cell.repo-mmap-child .foreignObject").style("display", (m) => s(m) < 20 || u(m) < 12 ? "none" : "").style(
      "font-size",
      (m) => s(m) < 40 || u(m) < 20 ? "6.5px" : s(m) < 60 || u(m) < 35 ? ".85em" : s(m) < 80 || u(m) < 55 ? "1em" : s(m) < 120 || u(m) < 95 ? "1.5em" : "2em"
    ).style(
      "line-height",
      (m) => s(m) < 40 || u(m) < 20 ? "7px" : s(m) < 60 || u(m) < 35 ? "1em" : "1.2em"
    ).style("font-family", "iransansxv");
    d.select(".repo-mmap-labelbody .repo-mmap-label").style("font-family", "iransansxv").style("display", (m) => s(m) < 25 || u(m) < 15 ? "none" : ""), d.select(".repo-mmap-labelbody .repo-mmap-labelp").style("display", (m) => s(m) < 25 || u(m) < 20 ? "none" : "").style("font-family", "iransansxv").text((m) => m.data.percent + "%");
  }, p = (d) => {
    d.select(".foreignObject").attr("width", (m) => Math.max(0.01, s(m))).attr(
      "height",
      (m) => m.children ? e.value.headerHeight : Math.max(0.01, u(m))
    );
  }, g = (d) => {
    d.select("rect").attr("width", (m) => Math.max(0.01, s(m))).attr("height", (m) => Math.max(0.01, (m.children, u(m)))).style(
      "fill",
      (m) => m.children ? e.value.headerColor : ne(m.data.percent, i).bgColor
    );
  };
  function v(d) {
    o.value = d, e.value.xscale.domain([d.x0, d.x1]), e.value.yscale.domain([d.y0, d.y1]);
    const m = c();
    p(m), g(m), h(), f(), e.value.node = d;
  }
  return { zoom: v };
}
function wl(t) {
  const e = k(t.externalChartConfig.width), n = k(t.externalChartConfig.height), r = k(), i = k(), o = Z(() => ({
    TipWinActive: -1,
    mapMode: "Squarify",
    percentRange: null,
    variationColorRange: null,
    transitionDuration: 500,
    supportsForeignObject: !0,
    backgroundColor: t.externalChartConfig.darkMode ? Y.dark.bgColor : Y.light.bgColor,
    zoom: u,
    headerHeight: t.externalChartConfig.headerHeight,
    selectedColor: t.externalChartConfig.darkMode ? Y.dark.selectedColor : Y.light.selectedColor,
    headerColor: t.externalChartConfig.darkMode ? Y.dark.headerColor : Y.light.headerColor,
    chartWidth: t.externalChartConfig.width,
    chartHeight: t.externalChartConfig.height,
    node: null,
    rootData: null,
    xscale: void 0,
    yscale: void 0,
    rootNode: void 0,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fireEvent: (...w) => {
    }
  })), { processParentCells: a } = vl({
    chartWrapper: i,
    chartConfig: o,
    isHovered: t.isHovered,
    darkMode: t.externalChartConfig.darkMode
  }), { style: l, processChildrenCells: s } = yl({
    chartWrapper: i,
    chartConfig: o,
    darkMode: t.externalChartConfig.darkMode,
    hoverDebounce: t.externalChartConfig.hoverDebounce,
    hoveredComponentHeight: t.externalChartConfig.hoveredComponentHeight,
    hoveredComponentWidth: t.externalChartConfig.hoveredComponentWidth,
    isHovered: t.isHovered,
    hoveredNodeData: t.hoveredNodeData,
    onClickCallback: t.externalChartConfig.onClickCallback,
    preview: t.externalChartConfig.preview,
    routeCallback: t.externalChartConfig.routeCallback
  }), { zoom: u } = xl({
    chartWrapper: i,
    chartConfig: o,
    chartWidth: e,
    chartHeight: n,
    darkMode: t.externalChartConfig.darkMode
  }), c = () => {
    o.value.xscale = it().range([0, E(e)]), o.value.yscale = it().range([0, E(n)]);
  }, h = () => {
    r.value = il().tile(wn).round(!0).size([Number(E(e)), Number(E(n))]).paddingTop(
      (w) => w.y1 - w.y0 > 50 ? o.value.headerHeight : 0
    ).paddingRight(2).paddingBottom(2).paddingRight(2);
  }, f = () => {
    i.value = Ut(t.treemap.value).append("svg:svg").attr("width", E(e)).attr("height", E(n)).attr("id", "treemap").append("svg:g").on("mouseout", () => {
      t.isHovered.value = !1;
    });
  };
  function p() {
    n.value = t.treemap.value.clientHeight.toString(), e.value = t.treemap.value.clientWidth.toString(), c(), h(), f(), d(t.externalChartConfig.data);
  }
  function g(w) {
    if (t.externalChartConfig.percentRange) {
      const { cloned: _ } = ge(w, { deep: !0 });
      return _.value.children = _.value.children.map((C) => (C.children = C.children.filter((b) => b.percent >= Pe[t.externalChartConfig.percentRange].min && b.percent < Pe[t.externalChartConfig.percentRange].max), { ...C })), _.value;
    }
    return w;
  }
  const v = (w) => {
    o.value.rootNode = r.value(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-expect-error
      pe(w).sum((_) => Number(_[t.externalChartConfig.sortBy])).sort((_, C) => C.value && _.value ? C.value - _.value : 0)
    );
  };
  function d(w, _) {
    const C = E(w);
    if (C) {
      const { cloned: b } = ge(C, { deep: !0 });
      if (b.value = g(C), _ && o.value.fireEvent && o.value.fireEvent("maploaded", b.value), v(b.value), a(), !o.value.rootNode.children) return;
      s(), o.value.zoom(o.value.rootNode);
    }
  }
  function m() {
    const w = t.treemap.value;
    w && (e.value = w.clientWidth.toString(), n.value = w.clientHeight.toString(), Ut(document.body).select("svg#treemap").attr("width", e.value).attr("height", n.value), o.value.xscale = it().range([0, e.value]), o.value.yscale = it().range([0, n.value]), o.value.node && o.value.zoom(o.value.node));
  }
  return addEventListener("resize", m), {
    initChart: p,
    onLoadData: d,
    onResize: m,
    style: l
  };
}
const bl = /* @__PURE__ */ Nn({
  __name: "MarketMap",
  props: {
    data: {},
    width: { default: "800" },
    height: { default: "800" },
    hoveredComponent: { default: null },
    hoveredComponentWidth: { default: "400" },
    hoveredComponentHeight: { default: "640" },
    headerHeight: { default: 20 },
    hoverDebounce: { default: 0 },
    darkMode: { type: Boolean, default: !1 },
    preview: { default: "symbol" },
    sortBy: { default: "value" },
    percentRange: { default: null },
    routeCallback: {},
    onClickCallback: {}
  },
  setup(t) {
    const e = t, n = k(), r = k(!1), i = k(), { width: o, height: a } = Xn(n), { initChart: l, onLoadData: s, onResize: u, style: c } = wl({
      externalChartConfig: e,
      treemap: n,
      isHovered: r,
      hoveredNodeData: i
    });
    return re(() => {
      l();
    }), at(
      e,
      () => {
        s(e.data);
      },
      {
        deep: !0
      }
    ), at([o, a], () => {
      u();
    }), (h, f) => (Xt(), me(An, null, [
      En("div", {
        ref_key: "treemap",
        ref: n,
        class: "w-full h-full"
      }, null, 512),
      r.value && h.hoveredComponent && h.preview !== "empty" ? (Xt(), me("div", {
        key: 0,
        class: "fixed z-200",
        style: Sn(E(c))
      }, [
        (Xt(), $n(Tn(h.hoveredComponent), Rn(Fn({ ...i.value })), null, 16))
      ], 4)) : On("", !0)
    ], 64));
  }
});
export {
  bl as MarketMap
};
